/*
 * @Author: chenx
 * @CreatedDate: Do not edit
 * @LastEditTime: 2021-03-30 16:51:08
 * @Description: 招采卡片
 */
const zcUrl = process.env.VUE_APP_API
import request from '@/http'
export const apiLabour = {
  // 概算金额
  getTenderMoney: () => request.get(`${zcUrl}/ov1/mechanicalLabor/tenderMoneySelect`),
  // 报名结束时间
  getTime: () => request.get(`${zcUrl}/ov1/mechanicalLabor/tenderTimeSelect`),
  // 招标方式
  getTenderTypeBidWay: () => request.get(`${zcUrl}/ov1/mechanicalLabor/tenderTypeBidWaySelect`),
  // 获取劳工公司列表
  getLaborList: (data) => request.post(`${zcUrl}/ov1/mechanicalLabor/tenderApplyingList`, data)
}